import { render, staticRenderFns } from "./WidgetTitle.vue?vue&type=template&id=aa1caa8a&"
import script from "./WidgetTitle.vue?vue&type=script&lang=ts&"
export * from "./WidgetTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports